import { createRouter, createWebHashHistory } from 'vue-router'

import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import ForgetView from '@/views/ForgetView.vue'

const routes = [
  {
    path: '/', // 主页
    redirect:'/index'    
  },
  {
    path: '/index', // 主页
    name: 'home',
    component: HomeView
  },
  {
    path: '/login', // 登录页
    name: 'login',
    component: LoginView
  },
  {
    path: '/forget', // 登录页
    name: 'forget',
    component: ForgetView
  },
  {
    path: '/deviation', // 偏差率
    name: 'deviation',
    component: ()=>import('../views/DeviationView.vue')
  },
  {
    path: '/record', //采集记录
    name: 'record',
    component: ()=>import('../views/RecordView.vue')
  },
  {
    path: '/responsiblelist', //  负责人 待办结+已办结 
    name: 'responsiblelist',
    component: ()=>import('../views/ResponsibleView.vue')
  },
  {
    path: '/applyDetail', //    申请详情 
    name: 'applyDetail',
    component: ()=>import('../views/ApplyDetailView.vue')
  },
  {
    path: '/concludeform', //  办结录入 
    name: 'concludeform',
    component: ()=>import('../views/ConcludeFormView.vue')
  },
  {
    path: '/newinsurance', //  新保录入
    name: 'newinsurance',
    component: ()=>import('../views/NewInsurance.vue')
  },
  {
    path: '/field', //  联保体 + 外地回流 + 上年存量采集
    name: 'field',
    component: ()=>import('../views/FieldView.vue')
  },
  {
    path: '/activeprotect', // 主动承保
    name: 'activeprotect',
    component: ()=>import('../views/ActiveprotectView.vue')
  },
  // 客户自助投保 selfinsure
  {
    path: '/selfinsure', // 客户自助投保 
    name: 'selfinsure',
    component: ()=>import('../views/selfinsureView.vue')
  },
  {
    path: '/insuremust', // 投保须知
    name: 'insuremust',
    component: ()=>import('../views/InsuremustView.vue')
  },
  {
    path : '/selectcompany', // 选择意向公司
    name: 'selectcompany',
    component: ()=>import('../views/selectcompany.vue')
  },
  {
    path: '/selfinsureone', // 自助投保第一步
    name: 'selfinsureone',
    component: ()=>import('../views/SelfinsureoneView.vue'),
    meta: {
      keepAlive: true // 需要被缓存
    },
  },
  {
    path: '/selfinsuretwo', // 自助投保第二步 非新车信息录入2
    name: 'selfinsuretwo',
    component: ()=>import('../views/SelfinsuretwoView.vue')
  },
  {
    path: '/selfinsurethree', // 自助投保第三步 资料上传
    name: 'selfinsurethree',
    component: ()=>import('../views/SelfinsurethreeView.vue')
  },
  {
    path: '/selfinsurethreewyc', // 自助投保第三步 资料上传 -- 网约车
    name: 'selfinsurethreewyc',
    component: ()=>import('../views/SelfinsurethreeWycView.vue')
  },
  {
    path: '/myselflist', // 我的列表
    name: 'myselflist',
    component: ()=>import('../views/MyselflistView.vue')
  },

  {
    path: '/selflogin', // 我的列表 登录
    name: 'selflogin',
    component: ()=>import('../views/SelfLoginView.vue')
  },
  {
    path: '/webview', // 我的列表 登录
    name: 'webview',
    component: ()=>import('../views/webview.vue')
  },
  // {
  //   path: '/insuerdataMaintenance', // 承保数据维护
  //   name: 'insuerdataMaintenance',
  //   component: ()=>import('../views/insuerdataMaintenance.vue')
  // },
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

let filterList = [
  '/login','/forget','/insuremust','/selfinsureone','/selfinsuretwo','/selfinsurethree','/myselflist','/selflogin','/webview',
  '/selfinsurethreewyc','/selectcompany','/selfinsure'
]
router.beforeEach((to,from,next)=>{
  sessionStorage.setItem('fromPath',from.path)
  if(localStorage.getItem('tz_token')){
    next()
  }else{
    // if(to.path == '/login' || to.path == '/forget'){
      if( filterList.includes(to.path)  ){
      next()
    }else{
      next('/login')
    }
  }
})

export default router
